import { render, staticRenderFns } from "./ProofreadingConfirmationDialog.vue?vue&type=template&id=855ad242&scoped=true"
import script from "./ProofreadingConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingConfirmationDialog.vue?vue&type=style&index=0&id=855ad242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855ad242",
  null
  
)

export default component.exports